<template>
  <div class="top-scroll">
    <button v-scroll-to="{ element: '#header', duration: 500 }" v-show="visible">
      <font-awesome-icon icon="arrow-up" />
    </button>
  </div>
</template>

<script>

export default {
  name: 'Scroll2Top',
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.toggleVisibility)
  },
  methods: {
    toggleVisibility() {
      this.visible = window.pageYOffset > 400
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";

button {
  display: none;

  @include tablet {
    display: block;
    position: fixed;
    bottom: 40px;
    right: 20px;
    background: $primary-0;
    box-shadow: $shadow-medium;
    height: 50px;
    width: 50px;
    color: $light-0;
    border: none;
    border-radius: 100%;
    font-size: 20px;
    cursor: pointer;
  }

  @include desktop {
    right: 100px;
  }
}


</style>
